import styles from "@/styles/Form.module.scss";
import classnames from "classnames";
import { forwardRef } from "react";
import ErrorMessage from "./ErrorMessage";
import { usePreventContextMenu } from "@/hooks";

const TextAreaField = forwardRef((props, ref) => {
  const {
    error,
    className,
    title,
    help,
    caption,
    required,
    placeholder,
    defaultValue,
    disabled,
    ..._props
  } = props;

  const [on, off] = usePreventContextMenu();

  return (
    <div className={styles.inputField}>
      {title && (
        <legend
          className={classnames(styles.formTitle, {
            [styles.required]: required,
          })}
        >
          {title}
        </legend>
      )}
      {help && <span className={styles.help}>{help}</span>}
      <div className={styles.commentArea}>
        <textarea
          ref={ref}
          placeholder={placeholder}
          className={classnames(styles.textInput, className)}
          defaultValue={defaultValue ? defaultValue : ""}
          required={required}
          disabled={disabled}
          onFocus={off}
          onBlur={on}
          {..._props}
        />
        {error && <ErrorMessage msg={error} />}
        {caption && <p className={styles.textInputCaption}>{caption}</p>}
      </div>
    </div>
  );
});
TextAreaField.displayName = "TextAreaField";
export default TextAreaField;